import Vue from "vue";
import { http } from '@/shared/https'
import { AppConstants as _app} from "@/shared/app.constants";
import AuthService from '@/services/auth.service';
import { User } from 'oidc-client';

const auth = new AuthService();

export default class PermissionService extends Vue {
    public ppoHasPermission(initiativeId: number) {
        return auth.getUser().then((user: User) => {
            // get user initiaive
            if (user.profile.initiative_id) {
                let userInitiatives = JSON.parse(user.profile.initiative_id);

                if (userInitiatives.some(i => i.InitiativeId == initiativeId  && i.RoleId == _app.appRoles.ProgramOfficer)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        });
    }
}